import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles, getBKGStyles, setVisibility, } = styleService.utils;
const ProductTagStyled = styled.span `
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  border-radius: ${({ cornerRadius }) => cornerRadius.web};
  ${({ text }) => getFontStyles(text)};
  ${({ bkg }) => getBKGStyles(bkg)};
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
  clear: both;
  display: inline-block;
  overflow: hidden;
  position: ${({ position }) => (position ? 'absolute' : 'relative')};
  ${({ position }) => position};
  white-space: nowrap;
  ${({ visible, visibility }) => visibility && setVisibility(visible)};
`;
const ProductTag = ({ tag, style, position, className, visibility, }) => (React.createElement("div", { className: className }, tag && React.createElement(ProductTagStyled, Object.assign({}, style, { visibility: visibility, position: position }), tag)));
export default ProductTag;
